/**
 * @fileoverview Sign-up page with full-screen centered layout.
 * @module features/auth/pages/SignUpPage
 */

import { ReactElement, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { authService } from '@/lib/authService'
import { SignUpForm } from '@/shared/components/ui/SignUpForm'

/**
 * Sign-up page that redirects authenticated users to the home page.
 *
 * @component
 * @example
 * ```tsx
 * <SignUpPage />
 * ```
 */
export function SignUpPage(): ReactElement {
  const navigate = useNavigate()

  useEffect(() => {
    if (authService.isAuthenticated()) {
      navigate('/dashboard')
    }
  }, [navigate])

  return (
    <div className="flex min-h-svh w-full items-center justify-center p-6 md:p-10">
      <div className="w-full max-w-sm">
        <SignUpForm />
      </div>
    </div>
  )
}
